// Modules
import React from 'react';
import { Link } from 'react-router-dom';
import type { RootState } from '../types/store';

// New
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import { CirclePlus, Instagram, Play } from "lucide-react";
import { useSelector } from 'react-redux';
import Header from "../components/ui-header.tsx";
import LandingImg from "../assets/landingpage.png";

const Index = () => {
    const translate = useSelector((state: RootState) => state.ui.language.index);

    const theme = useTheme();
    return (
        <Grid container display={"flex"} height={"100%"} alignItems={"center"}>
            <Grid size={{ sm: 12, md: 8 }}>
                <Header size="md" sx={{ marginTop: 2 }} text={translate.title} />
                <Typography color={theme.palette.secondary.light} marginTop={2}>
                    {translate.intro.map((v, i) => {
                        return (<React.Fragment key={i}>{v}<br /></React.Fragment>);
                    })}
                </Typography>
                <Box display={"flex"} color={theme.palette.secondary.light} marginTop={2}>
                    <Typography marginRight={2}>{translate.socialMedia}</Typography>
                    <Box sx={{ cursor: "pointer" }}>
                        <Link to="https://instagram.com/moesbeergame" target="_blank" className="link-unstyled"><Instagram /></Link>
                    </Box>
                </Box>
                <Stack marginTop={2} direction={"row"} gap={2}>
                    <Link to="/create">
                        <Button variant="contained" startIcon={<CirclePlus size={20} />}>
                            {translate.create}
                        </Button>
                    </Link>
                    <Link to="/join">
                        <Button color="secondary" startIcon={<Play size={20} />} variant="contained">
                            {translate.join}
                        </Button>
                    </Link>
                </Stack>
                <Box marginTop={2.5}>
                    <Typography
                        variant="caption"
                        sx={{
                            color: theme.palette.secondary.light,
                            opacity: 0.5,
                            fontSize: '0.8rem',
                            letterSpacing: '0.04em',
                            transition: 'opacity 0.2s',
                            '&:hover': { opacity: 0.9 },
                        }}
                    >
                        v{import.meta.env.VITE_VERSION || "2.0.2"}
                    </Typography>
                </Box>
            </Grid>
            <Grid size={{ sm: 12, md: 4 }}>
                <Box component="img" src={LandingImg} alt="Landing" sx={{ width: { xs: "100%", md: "300px" } }} />
            </Grid>
        </Grid>
    );
};

export default Index;
